export const staticCardsData = [
  {
    title: 'Team members with no progress in the last 30 days',
    subTitle: '',
    value: 2,
    color: '',
  },
  {
    title: 'Team members with no feedback received',
    subTitle: '',
    value: 3,
    color: '',
  },
  {
    title: 'Team members with no shared feedback ',
    subTitle: '',
    value: 13,
    color: '',
  },
  {
    title: 'Average competency progress',
    subTitle: '',
    value: '40%',
    color: '',
  },
];

export const staticLineChartData = {
  nodes: [
    {
      id: '121',
      name: 'Engineering',
    },
    {
      id: '122',
      name: 'People & Culture',
    },
    {
      id: '123',
      name: 'Product',
    },
    {
      id: '124',
      name: 'Sales',
    },
  ],
  series: [
    {
      data: [1, 30, 15, 22],
      id: '121',
    },
    {
      data: [15, 22.4, 14, 12],
      id: '122',
    },
    {
      data: [14, 28, 11, 22],
      id: '123',
    },
    {
      data: [11, 18, 21, 26],
      id: '124',
    },
  ],

  xaxis: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  yaxisRange: {
    start: 0,
    end: 30,
  },
};

export const staticBarChartData = {
  nodes: [
    {
      id: '121',
      name: 'Ownership',
    },
    {
      id: '122',
      name: 'Action-orientation',
    },
    {
      id: '123',
      name: 'Collaboration',
    },
    {
      id: '124',
      name: 'Customer centricity',
    },
    {
      id: '125',
      name: 'Manages ambiguity',
    },
    {
      id: '126',
      name: 'Innovation',
    },
    {
      id: '127',
      name: 'Accountability',
    },
  ],
  xaxis: ['Engineering', 'People & Culture', 'Product', 'Sales'],
  yaxisRange: {
    start: 0,
    end: 30,
  },
  series: [
    {
      data: [11, 12, 18, 22],
      id: '121',
    },
    {
      data: [5, 2.4, 9, 10],
      id: '122',
    },
    {
      data: [5, 2.4, 4, 7],
      id: '123',
    },
    {
      data: [4, 8, 8, 0],
      id: '124',
    },
    {
      data: [13, 20, 12.4, 9],
      id: '125',
    },
    {
      data: [12, 15, 8, 12],
      id: '126',
    },
    {
      data: [12, 5, 18, 11],
      id: '127',
    },
  ],
};
